<template>
  <div class="row">
    <div class="col-md-3">
      <button
        type="button"
        class="btn btn-sm btn-primary waves-effect waves-themed mr-1"
        @click="addRow()"
        :disabled="btnDisable"
      >
        行追加
      </button>
      <button
        type="button"
        class="btn btn-sm btn-primary waves-effect waves-themed mr-1"
        @click="delRow()"
        :disabled="btnDisable"
      >
        行削除
      </button>
    </div>
    <div class="col-md-auto ml-md-auto">
      <div class="row">
        <span style="color: red; padding-right: 20px"
          >※単価は、文字入力となるため、カンマや小数点が必要な場合は手入力して下さい。</span
        >
        <div class="col-md-auto contTitle">小計</div>
        <div class="col-md-auto contCnt">
          <input
            type="text"
            class="form-control form-control-sm mr-1 text-right"
            v-model="sum"
            disabled
          />
        </div>
        <div class="col-md-auto contTitle">請求金額</div>
        <div class="col-md-auto contCnt">
          <input
            type="text"
            class="form-control form-control-sm mr-1 text-right"
            v-model="sumTax"
            disabled
          />
        </div>
      </div>
    </div>
  </div>
  <div class="demo">
    <table class="table table-sm m-0 tableClaim">
      <thead class="bg-fusion-50">
        <tr>
          <th class="fixhead headClaim cwC_1">品名</th>
          <th class="fixhead headClaim cwC_2">数量</th>
          <th class="fixhead headClaim cwC_25">単位</th>
          <th class="fixhead headClaim cwC_3">単価</th>
          <th class="fixhead headClaim cwC_4">金額</th>
          <th class="fixhead headClaim cwC_5">消費税</th>
          <th class="fixhead headClaim cwC_6">税込金額</th>
          <th class="fixhead headClaim cwC_7">計算方法</th>
          <th class="fixhead headClaim cwC_8">備考</th>
        </tr>
      </thead>
      <tbody>
        <!-- ------------------- -->
        <Mo_claimlist_row
          v-for="item in items"
          :key="item.c_claim_rownum!"
          v-bind:item="item"
          v-model:btnDisable="btnDisable"
          @reCalc="sumCalc()"
        ></Mo_claimlist_row>
        <!-- ------------------- -->
      </tbody>
    </table>
  </div>
</template>
<script lang="ts">
import { Prop, Options, Vue } from "vue-property-decorator";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { EntityClaimDet } from "furukawa-common/src/common/entity/EntityClaimDet";

import Mo_claimlist_row from "../molecules/Mo_claimlist_row.vue";

@Options({
  components: {
    vSelect,
    Mo_claimlist_row,
  },
})
export default class Or_tableClaim extends Vue {
  //----------------------
  //DOM連携用プロパティ
  //----------------------
  @Prop({ required: true })
  items: EntityClaimDet[];

  sum = "0";
  sumTax = "0";

  btnDisable = false;

  //----------------------
  //セレクトボックス用プロパティ
  //----------------------
  //----------------------
  //モーダル用プロパティ
  //----------------------
  //----------------------
  //制御用メソッド
  //----------------------
  async mounted() {
    //
  }

  /**
   * buttonの有効無効を制御
   */
  eventAdjButton(btnDisableTmp: boolean) {
    this.btnDisable = btnDisableTmp;
  }
  //----------------------
  //基本操作用メソッド
  //----------------------

  delRow() {
    this.items.pop();
    this.sumCalc();
  }
  addRow() {
    if (15 <= this.items.length) {
      return;
    }

    let tmp = new EntityClaimDet();

    tmp.c_claim_det_id = -1;
    tmp.c_claim_rownum = this.items.length + 1;
    tmp.c_claim_det_taxrate = 3;
    tmp.c_claim_det_rounding = 0;

    this.items.push(tmp);
  }

  /**
   * 小計、請求金額の再計算
   */
  sumCalc() {
    let tmpSum = 0;
    let tmpSumTax = 0;

    for (const item of this.items) {
      if (item.c_claim_det_price != null && item.c_claim_det_price != "") {
        tmpSum += Number(item.c_claim_det_price.replace(/,/g, ""));
      }
      if (
        item.c_claim_det_price_sum != null &&
        item.c_claim_det_price_sum != ""
      ) {
        tmpSumTax += Number(item.c_claim_det_price_sum!.replace(/,/g, ""));
      }
    }

    this.sum = tmpSum.toString();
    this.sumTax = tmpSumTax.toString();

    while (
      this.sum != (this.sum = this.sum.replace(/^(-?\d+)(\d{3})/, "$1,$2"))
    );
    while (
      this.sumTax !=
      (this.sumTax = this.sumTax.replace(/^(-?\d+)(\d{3})/, "$1,$2"))
    );
  }
  getSum(): string[] {
    let res: string[] = [];
    res.push(this.sum);
    res.push(this.sumTax);
    return res;
  }

  //----------------------
  //モーダル用メソッド
  //----------------------
}
</script>
<style scoped>
thead > tr {
  border: 1px solid #dcdfe6;
}
input:disabled {
  background-color: #fff;
}
.headClaim {
  text-align: center;
}
.tableClaim tbody tr {
  border-bottom: 1px solid #ccc;
}

.tableClaim td {
  border-right: 1px solid #ccc;
}
.tableClaim tr > td:last-child {
  border-right: none;
}

.cwC_1 {
  width: 350px;
  min-width: 350px;
}
.cwC_2 {
  width: 80px;
  min-width: 80px;
}
.cwC_25 {
  width: 80px;
  min-width: 80px;
}
.cwC_3 {
  width: 150px;
  min-width: 150px;
}
.cwC_4 {
  width: 150px;
  min-width: 150px;
}
.cwC_5 {
  width: 120px;
  min-width: 120px;
}
.cwC_6 {
  width: 150px;
  min-width: 150px;
}
.cwC_7 {
  width: 125px;
  min-width: 125px;
}
.cwC_8 {
  width: 150px;
  min-width: 150px;
}

.tableClaim tr:hover td > input,
.tableClaim tr:hover td > select,
.tableClaim tr:hover td {
  background-color: #dddddd;
}

.demo {
  overflow: auto;
}

@media (min-width: 1500px) {
  .demo {
    overflow-x: hidden;
  }
}
.tableClaim {
  border: 1px solid #dcdfe6;
}

thead th {
  border: 1px solid #dcdfe6;
  color: #606266;
  vertical-align: bottom;
  padding-right: 1.5em;
  background: linear-gradient(#f4f5f8, #f1f3f6);
  min-width: auto;
  width: auto;
  padding: 0.75em 1.5em 0.75em 0.75em !important;
}
</style>
